// The "not being called" marker on a campaign enrollment
// (graham workflows/processor.py _note_decline: context.last_decline / decline_count).

import type { EnrollmentContext } from "../types/outreach.types"

/** At this many refusals in a row the backend raises an "Outreach is stuck" inbox item. */
export const DECLINE_STUCK_AFTER = 3

export interface DeclineMarker {
  /** "not being called: <reason>" */
  text: string
  reason: string
  count: number
  /** When the booking was last refused (ISO, server local time). */
  at: string | null
  /** decline_count >= DECLINE_STUCK_AFTER: shown emphasised. */
  stuck: boolean
}

export function declineMarker(context: EnrollmentContext | Record<string, unknown> | null | undefined): DeclineMarker | null {
  const ctx = (context || {}) as EnrollmentContext
  const last = ctx.last_decline
  if (!last || typeof last !== "object") return null
  const reason = String(last.reason || "").trim() || "booking refused"
  const raw = Number(ctx.decline_count)
  const count = Number.isFinite(raw) && raw > 0 ? Math.floor(raw) : 1
  return {
    text: `not being called: ${reason}`,
    reason,
    count,
    at: last.at || null,
    stuck: count >= DECLINE_STUCK_AFTER,
  }
}
